<template>
  <public-layout class="page-resource">
    <section class="section is-left-aligned">
      <div class="container">
        <Loader v-if="loading"></Loader>
        <div class="columns" v-else>
          <div class="column is-4">
            <figure class="image">
              <img :src="resource.thumb">
            </figure>
          </div>
          <div class="column is-7 is-offset-1">
            <h2 class="resource-title">{{ resource.title }}</h2>
            <p class="resource-meta">
              <span class="resource-subject tag" :class="`is-category-${subject.id}`" v-for="subject in resource.subjects" :key="subject.id" :style="getTagColor(subject)">{{ subject.name }}</span>
              <span class="resource-category">{{ resource.type.name }}</span>
            </p>
            <p class="resource-description">{{ resource.description }}</p>
            <div class="resource-meta">
              <div class="columns">
                <div class="column is-5">
                  <h4 class="resource-meta-title">Curricular Year</h4>
                  <p class="resource-meta-text">
                    <span v-for="(grade, index) in resource.grades" :key="index">{{ index === 0 ? '' : ', ' }}{{ grade.name }}</span>
                  </p>
                </div>
                <div class="column is-5">
                  <h4 class="resource-meta-title">Group Size</h4>
                  <p class="resource-meta-text">{{ resource.groupings.name }}</p>
                </div>
              </div>
              <div class="columns">
                <div v-if="resource.goals !== ''" class="column is-5">
                  <h4 class="resource-meta-title">Things I learned</h4>
                  <p class="resource-meta-text">{{ resource.goals }}</p>
                </div>
              </div>
            </div>
            <a class="button button-primary button-large"
               :class="{ 'is-loading': downloading }"
               :href="resource.url"
               target="_blank"
               @click="download"
               v-if="isAuthenticated">Download</a>
            <ResourceSignupBox :redirectTo="$route.fullPath" v-else></ResourceSignupBox>
          </div>
        </div>
      </div>
    </section>

    <section class="section is-left-aligned">
      <div class="container">
        <h2 class="title is-3">Related Resources</h2>
        <resource-thumbnail-list :resources="related"></resource-thumbnail-list>
      </div>
    </section>
  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import Loader from '@/components/Loader'
import ResourceSignupBox from '@/components/ResourceSignupBox'
import ResourceThumbnailList from '@/components/ResourceThumbnailList'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    PublicLayout,
    Loader,
    ResourceSignupBox,
    ResourceThumbnailList
  },

  watch: {
    '$route.params.id': 'fetch'
  },

  computed: {
    ...mapState('resource', {
      resource: state => state.resource,
      related: state => state.related,
      loading: state => state.isFetching
    }),

    isAuthenticated () {
      return this.$store.state.isAuthenticated
    }
  },

  methods: {
    ...mapActions('resource', {
      getResource: 'get',
      saveResource: 'save',
      getRelatedResources: 'getRelated'
    }),

    fetch (resourceId) {
      this.getResource(resourceId)
      this.getRelatedResources(resourceId)
    },

    download () {
      if (this.downloading) {
        return false
      }

      this.downloading = true
      this.saveResource().then(resource => {
        this.downloading = false
      })
    },

    getTagColor (tag) {
      return { 'background-color': tag.color ? tag.color : 'inherit' }
    }
  },

  created () {
    this.fetch(this.$route.params.id)
  },

  data () {
    return {
      downloading: false
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.page-resource .main {

  .section:nth-child(2) {
    padding-top: 0;
  }
}

.resource-title {
  margin-bottom: 1rem;
  @include text-size-xl();
  font-weight: 600;
  color: $color-text-dark;

  @media screen and (min-width: 768px) {
    @include text-size-xxxl();
  }
}

.resource-category {
  margin-left: 1rem;
  margin-bottom: .5rem;
  text-transform: uppercase;
  @include text-size-xs();
  font-weight: 600;
}

.resource-description {
  margin-bottom: 1.5rem;
}

.resource-meta {
  margin-bottom: 1.5rem;

  @media screen and (min-width: 768px) {
    margin-bottom: 2rem;
  }
}

.resource-meta-title {
  margin-bottom: .5rem;
  color: $color-text-dark;
}

</style>



// WEBPACK FOOTER //
// src/pages/ResourcePage.vue